import { render, staticRenderFns } from "./SortOrderHelpList.vue?vue&type=template&id=34338a00&"
import script from "./SortOrderHelpList.vue?vue&type=script&lang=js&"
export * from "./SortOrderHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports